
import React from 'react';

import FSIndex from "@dndComponents/FSIndex";

export default function BastionFacilityIndex() {
  return (
    <FSIndex
      data_type="bastion_facility"
      quick_fields={["bastion_size","special_facility"]}
    />
  );
}
